import { APIRoute } from '@/modules/utils'
import { HydraCollection } from 'emt-library'
import { DogSize } from '@/dataV3/Animal/DogSize'

export type Response = HydraCollection<DogSize>

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/dog_sizes',
}
